export default __webpack_public_path__ + "static/media/IconEmail.62684218.svg";